import React from 'react';
import { Circle, G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const DotsHorizontal: IconDef = {
  svg: (
    <G>
      <Circle cx="12" cy="12" r="9.5" />
      <Path
        d="M11.9982 12.7432C12.4073 12.7432 12.7389 12.4116 12.7389 12.0025C12.7389 11.5934 12.4073 11.2617 11.9982 11.2617C11.5891 11.2617 11.2575 11.5934 11.2575 12.0025C11.2575 12.4116 11.5891 12.7432 11.9982 12.7432Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M17.1834 12.7432C17.5925 12.7432 17.9241 12.4116 17.9241 12.0025C17.9241 11.5934 17.5925 11.2617 17.1834 11.2617C16.7743 11.2617 16.4426 11.5934 16.4426 12.0025C16.4426 12.4116 16.7743 12.7432 17.1834 12.7432Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6.81301 12.7432C7.22211 12.7432 7.55375 12.4116 7.55375 12.0025C7.55375 11.5934 7.22211 11.2617 6.81301 11.2617C6.40391 11.2617 6.07227 11.5934 6.07227 12.0025C6.07227 12.4116 6.40391 12.7432 6.81301 12.7432Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  ),
  svgStyles(color) {
    return {
      stroke: color,
    };
  },
};
